import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'modules/maya/components/Heading';
import MayaLayout from 'modules/maya/components/MayaLayout';
import StrategicImperativeForm from 'modules/maya/components/StrategicImperativeForm/StrategicImperativeForm';
import useStrategicImperativeCreate from 'modules/maya/routes/StrategicImperativeCreate/StrategicImperativeCreate.hook';

const StrategicImperativeCreate: FC = () => {
  const { t } = useTranslation();
  const {
    handleCancelStrategicImperativeForm,
    handleSaveStrategicImperativeForm,
  } = useStrategicImperativeCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_strategic_imperative_form_create_title') }
      </Heading>
      <StrategicImperativeForm
        {
          ...{
            submitCallback: handleSaveStrategicImperativeForm,
            cancelCallback: handleCancelStrategicImperativeForm,
          }
        }
      />
    </MayaLayout>
  );
};

export default StrategicImperativeCreate;
